import { ControlButtonGroup } from '@/components/diagrams/FlowChart/components/Controls/ControlButtonGroup';
import { Controls } from '@/components/diagrams/FlowChart/components/Controls/Controls';
import { FitViewButton } from '@/components/diagrams/FlowChart/components/Controls/FitViewButton';
import { ZoomInButton } from '@/components/diagrams/FlowChart/components/Controls/ZoomInButton';
import { ZoomOutButton } from '@/components/diagrams/FlowChart/components/Controls/ZoomOutButton';
import {
  UndoRedoButtonGroup,
  type UndoRedoButtonGroupProps,
} from '@/components/form/baseInputs/Button/UndoRedoButtonGroup';

import { useDiagramEditing } from '../../contexts/diagramEditing.context';
import { DIAGRAM_FIT_VIEW_OPTIONS } from '../../utils/diagramLayout.config';

/**
 * The element ID of the undo and redo panel. The zoom panel keeps the default
 * controls ID, so the two panels do not share an ID.
 */
const HISTORY_CONTROLS_ID = 'diagram-history-controls';

interface DiagramViewControlsProps {
  history?: UndoRedoButtonGroupProps;
}

/**
 * The canvas controls, as in the Figma handoff: undo and redo at the top
 * right, and the zoom controls at the bottom right. The artifact page exports
 * the diagram, so the canvas has no download button.
 */
export function DiagramViewControls({ history }: DiagramViewControlsProps) {
  const { locked } = useDiagramEditing();
  return (
    <>
      {!locked && history && (
        <Controls id={HISTORY_CONTROLS_ID} position="top-right">
          <UndoRedoButtonGroup {...history} />
        </Controls>
      )}
      <Controls position="bottom-right">
        <ControlButtonGroup>
          <FitViewButton fitViewOptions={DIAGRAM_FIT_VIEW_OPTIONS} />
          <ZoomInButton />
          <ZoomOutButton />
        </ControlButtonGroup>
      </Controls>
    </>
  );
}
